import React from 'react';
import {MenuItem} from '@gravity-ui/navigation';
import {
  PersonNutHex,
  PersonWorker,
  PersonGear,
  Persons,
  MapPin,
  CircleRuble,
  Tag,
  Sack,
  ShoppingBasket,
  SquareLetterT,
  SquareArticle,
  Megaphone,
  Briefcase,
  FileText,
  Bell,
  ClockArrowRotateLeft,
  House,
} from '@gravity-ui/icons';
import styles from './styles.module.scss';

export const accountMenuItems: MenuItem[] = [
  {
    id: 'accounts',
    title: 'Учетные записи',
    icon: PersonNutHex,
    tooltipText: 'Учетные записи',
    pinned: true,
    itemWrapper: (p, makeItem) => {
      return (
        <div className={styles.wrapper}>
          {makeItem({
            ...p,
            icon: (
              <div className={styles.icon}>
                <PersonNutHex />
              </div>
            ),
          })}
        </div>
      );
    },
  },
  {
    id: 'admins',
    title: 'Администраторы',
    icon: PersonWorker,
    href: '/accounts/admins',
  },
  {
    id: 'benefactors',
    title: 'Пользователи',
    icon: Persons,
    href: '/accounts/benefactors',
  },
  {
    id: 'fund-representatives',
    title: 'Представители Фондов',
    icon: PersonGear,
    href: '/accounts/fund-representatives',
  },
];

export const fundraisingsMenuItems: MenuItem[] = [
  {
    id: 'fundraisings',
    title: 'Сборы',
    icon: CircleRuble,
    tooltipText: 'Сборы',
    pinned: true,
    itemWrapper: (p, makeItem) => {
      return (
        <div className={styles.wrapper}>
          {makeItem({
            ...p,
            icon: (
              <div className={styles.icon}>
                <CircleRuble />
              </div>
            ),
          })}
        </div>
      );
    },
  },
  {
    id: 'appeals',
    title: 'Сборы',
    icon: ShoppingBasket,
    href: '/fundraisings/appeals',
  },
  {
    id: 'regions',
    title: 'Регионы',
    icon: MapPin,
    href: '/fundraisings/regions',
  },
  {
    id: 'category-groups',
    title: 'Группы категорий',
    icon: Tag,
    href: '/fundraisings/category-groups',
  },
  {
    id: 'funds',
    title: 'Фонды',
    icon: Sack,
    href: '/fundraisings/funds',
  },
];

export const contentMenuItems: MenuItem[] = [
  {
    id: 'content',
    title: 'Контент',
    icon: CircleRuble,
    tooltipText: 'Контент',
    pinned: true,
    itemWrapper: (p, makeItem) => {
      return (
        <div className={styles.wrapper}>
          {makeItem({
            ...p,
            icon: (
              <div className={styles.icon}>
                <SquareLetterT />
              </div>
            ),
          })}
        </div>
      );
    },
  },
  {
    id: 'blocks',
    title: 'Блоки',
    icon: SquareArticle,
    href: '/content/blocks',
  },
  {
    id: 'project-stories',
    title: 'Новости проекта',
    icon: Megaphone,
    href: '/content/project-stories',
  },
];

export const notificationsMenuItems: MenuItem[] = [
  {
    id: 'notifications',
    title: 'Сообщения',
    icon: Bell,
    tooltipText: 'Сообщения',
    pinned: true,
    itemWrapper: (p, makeItem) => {
      return (
        <div className={styles.wrapper}>
          {makeItem({
            ...p,
            icon: (
              <div className={styles.icon}>
                <Bell />
              </div>
            ),
          })}
        </div>
      );
    },
  },
  {
    id: 'notifications-list',
    title: 'Сообщения',
    icon: Bell,
    href: '/notifications/notifications-list',
  },
];
export const administrationsMenuItems: MenuItem[] = [
  {
    id: 'administration',
    title: 'Администрирование',
    icon: Briefcase,
    tooltipText: 'Администрирование',
    pinned: true,
    itemWrapper: (p, makeItem) => {
      return (
        <div className={styles.wrapper}>
          {makeItem({
            ...p,
            icon: (
              <div className={styles.icon}>
                <Briefcase />
              </div>
            ),
          })}
        </div>
      );
    },
  },
  {
    id: 'consents-documents',
    title: 'Документы согласия',
    icon: FileText,
    href: '/administration/consents-documents',
  },
  {
    id: 'client-versions',
    title: 'Версии приложения',
    icon: ClockArrowRotateLeft,
    href: '/administration/client-versions',
  },
];

export const representativeMenuItems: MenuItem[] = [
  {
    id: 'representative',
    title: 'Кабинет',
    icon: Briefcase,
    tooltipText: 'Кабинет',
    pinned: true,
    itemWrapper: (p, makeItem) => {
      return (
        <div className={styles.wrapper}>
          {makeItem({
            ...p,
            icon: (
              <div className={styles.icon}>
                <Briefcase />
              </div>
            ),
          })}
        </div>
      );
    },
  },
  {
    id: 'applications',
    title: 'Заявки',
    icon: FileText,
    href: '/applications',
  },
];

export const projectMenuItems: MenuItem[] = [
  {
    id: 'project',
    title: 'Проект',
    icon: House,
    tooltipText: 'Проект',
    pinned: true,
    itemWrapper: (p, makeItem) => {
      return (
        <div className={styles.wrapper}>
          {makeItem({
            ...p,
            icon: (
              <div className={styles.icon}>
                <House />
              </div>
            ),
          })}
        </div>
      );
    },
  },
  {
    id: 'project-info',
    title: 'Проект',
    icon: CircleRuble,
    href: '/project',
  },
  {
    id: 'partners',
    title: 'Партнеры',
    icon: Persons,
    href: '/project/partners',
  },
  {
    id: 'documents',
    title: 'Документы',
    icon: FileText,
    href: '/project/documents',
  },
];
